module.exports = __webpack_public_path__ + "img/ticker-light-small.89e8fc3f.svg";